import request from '@/utils/request'

// 清單頁
export function getCustomerCompanies(query) {
  return request({
    url: '/Advertisements/CustomerCompanies',
    method: 'get',
    params: query,
  })
}

// 清單頁+廣告
export function getCustomerCompaniesFullData(query) {
  return request({
    url: '/Advertisements/CustomerCompaniesFullData',
    method: 'get',
    params: query,
  })
}
// 取得 廣告詳情
export function getAdvertisementsManagement(id) {
  return request({
    url: '/Advertisements/Advertisements',
    method: 'get',
    params: { id },
  })
}

// 新增/編輯 商家
export function setCustomerCompaniesManagement(data) {
  return request({
    url: '/Advertisements/CustomerCompanies',
    method: 'patch',
    data,
  })
}

// 新增/編輯 廣告
export function setAdvertisementsManagement(data) {
  return request({
    url: '/Advertisements/Advertisements',
    method: 'patch',
    data,
  })
}

// 新增/編輯 廣告-版位配對
export function setAdvertisementSlotMappings(data) {
  return request({
    url: '/Advertisements/AdvertisementSlotMappings',
    method: 'patch',
    data,
  })
}

// 刪除 廣告-版位配對
export function deleteAdvertisementSlotMappings(data) {
  return request({
    url: '/Advertisements/AdvertisementSlotMappings',
    method: 'delete',
    params: data,
  })
}

// 版位清單頁
export function getSlotsManagement(query) {
  return request({
    url: '/Advertisements/Slots',
    method: 'get',
    params: query,
  })
}

// 新增/編輯 版位
export function setSlotsManagement(data) {
  return request({
    url: '/Advertisements/Slots',
    method: 'patch',
    data,
  })
}

// 取得 版位底下被設定了那些廣告
export function getAdvertisementsBySlot(query) {
  return request({
    url: '/Advertisements/AdvertisementsBySlot',
    method: 'get',
    params: query,
  })
}
